module.exports = __webpack_public_path__ + "static/media/newline7.dd69b0f3.jpg";